import { gql } from "@apollo/client"

export const createOneTeacherMutation = gql`
  mutation createOneTeacher($data: teacherInput) {
    createOneTeacher(data: $data) {
      id
      status
      error {
        statusCode
        message
      }
    }
  }
`

export const getAllTeachersQuery = gql`
  query getAllTeachers(
    $searchString: String
    $pageNumber: Float
    $pageLimit: Float
    $schoolId: String
  ) {
    getAllTeachers(
      searchString: $searchString
      pageNumber: $pageNumber
      pageLimit: $pageLimit
      schoolId: $schoolId
    ) {
      items {
        id
        name
        schoolId
        school {
          id
          name
        }
        kids {
          id
          name
          dob
          gender
          totalCoins
          totalPoints
        }
      }
    }
  }
`
export const deleteQuizQuestionMutation = gql`
  mutation deleteOneTeacher($id: String!) {
    deleteOneTeacher(id: $id) {
      id
      status
      error {
        statusCode
        message
      }
    }
  }
`
export const getOneQuizQuestionQuery = gql`
  query getQuizQuestion($id: Int!) {
    getOneQuizQuestion(id: $id) {
      id
      quizMasterId
      question
      error {
        statusCode
        message
      }
    }
  }
`
export const createQuizQuestionMutation = gql`
  mutation createQuizQuestion($data: quizQuestionsInput) {
    createQuizQuestion(data: $data) {
      id
      status
      error {
        statusCode
        message
      }
    }
  }
`
export const updateOneTeacherMutation = gql`
  mutation updateOneTeacher($id: String!, $data: teacherInput) {
    updateOneTeacher(id: $id, data: $data) {
      id
      status
      error {
        statusCode
        message
      }
    }
  }
`
export const getAllAgeGroup = gql`
  query getAgeGroups(
    $searchString: String
    $pageNumber: Float
    $pageLimit: Float
  ) {
    getAllAgeGroupMasters(
      searchString: $searchString
      pageNumber: $pageNumber
      pageLimit: $pageLimit
    ) {
      items {
        id
        ageGroupTitle
      }
    }
  }
`
export const getKidProfilesQuery = gql`
  query getKidProfiles(
    $parentId: Int
    $searchString: String
    $pageNumber: Float
    $pageLimit: Float
  ) {
    getAllKidProfiles(
      parentId: $parentId
      searchString: $searchString
      pageNumber: $pageNumber
      pageLimit: $pageLimit
    ) {
      items {
        id
        name
        dob
        gender
        isActive
        tagline
        parentId

        createdDate
        totalCoins
        totalPoints
        photoURL

        error {
          statusCode
          message
        }
      }
      pagination {
        pageNumber
        pageLimit
        totalCount
      }
    }
  }
`
